<script setup lang="ts">
import {useModalStore} from "../../../store/modal";
import ActionModalBase from "../ActionModalBase.vue";

const modalStore = useModalStore()
</script>

<template>
    <action-modal-base>
        <button @click.prevent="modalStore.open('AssignChat', {id: modalStore.props.id}, 'body', 'bottom-right')">
            {{ modalStore.props.assignee ? "Reassign" : "Assign" }}
        </button>
        <button @click.prevent="modalStore.open('CompleteChat', {id: modalStore.props.id}, 'body', 'bottom-right')">
            Mark as complete
        </button>
    </action-modal-base>
</template>

<style scoped lang="scss">

</style>
